import { render, staticRenderFns } from "./GoetelInput.vue?vue&type=template&id=3e2d067e&scoped=true&"
import script from "./GoetelInput.vue?vue&type=script&lang=js&"
export * from "./GoetelInput.vue?vue&type=script&lang=js&"
import style0 from "./GoetelInput.vue?vue&type=style&index=0&id=3e2d067e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d067e",
  null
  
)

export default component.exports